//对于axios二次封装
import axios from "axios";
// 引入store
import store from '@/store'


/**
 * 自定义错误类
 * @class FetchError
 * @extends {Error}
 */
class FetchError extends Error {
  constructor(error) {
    // console.log(error);
    super();
    if (typeof error === 'string') {
      this.message = error;
    } else {
      this.code = error.code;
      this.message = error.message || error.msg;
      this.data = error.data;
      // this.stack = error.stack;
    }
  }
}

//1.利用axios对象的方法create,创建axios的实例
const requests = axios.create({
  //基础路径
  // baseURL: 'https://www.gyhauto.com/api/',//正式环境
  baseURL: 'https://tapi.apbenben.com/',//测试环境
  // baseURL: 'http://192.168.1.9:8084/',//本地环境
  //设置请求超时的时间
  timeout: 5000
});

//2.请求拦截器
requests.interceptors.request.use((config) => {

  // 设置请求头中的uuid
  // if(store.state.detail.uuid_token){
  config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
  config.headers['Authorization-verify'] = "XCX"
  config.headers['Accept-Language'] = `${localStorage.getItem('language')}` || 'en'
  // }
  // if(store.state.user.token){
  //     config.headers.token = store.state.user.token
  // }


  return config;
});

//3.响应拦截器
requests.interceptors.response.use((res) => {
  if (res.data.code === 100009) {
    localStorage.removeItem('token')
    // window.location.href = '/#/login'
  }
  // 状态码处理
  if (res.data.code === 200) {
    // 成功状态
    return res.data || [];
  }
  throw new FetchError({
    code: res.status,
    message: res.data.msg
  });
}, (e) => {

  // 响应失败的回调函数
  throw new FetchError(e);

})

export default requests